import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { CrudRows } from "../../../common/types";
import { ShowFilesCompact } from "../../../common/controls";
import { IMenuAction } from "../../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type AssociatedDocumentEditionViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  fileFiles: CrudRows;
  fileViewAction?: IMenuAction[];
  typeValue: { displayId: string; id: string } | null;
  notesValue?: { displayId: string; id: string } | null;
  notes: string;
  publisherConfigurationDisplayValue?: { displayId: string; id: string } | null;
  publisherConfigurationDisplay: string;
  authorsDisplayValue?: { displayId: string; id: string } | null;
  authorsDisplay: string;
};

export const AssociatedDocumentEditionViewForm: React.FC<AssociatedDocumentEditionViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      name = "",
      fileFiles,
      fileViewAction,
      typeValue,
      notes = "",
      publisherConfigurationDisplay = "",
      authorsDisplay = "",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupAssociatedDocumentEditionLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={name}
                  label={langStore.AssociatedDocumentEditionNameLabel}
                />
                <ShowFilesCompact
                  rows={fileFiles}
                  showLabel={true}
                  label={langStore.AssociatedDocumentEditionFileLabel}
                  menuActions={fileViewAction}
                  columns={[
                    { name: "mimetype", title: langStore.fileTypeLabel },
                    { name: "name", title: langStore.fileNameLabel },
                    { name: "formattedSize", title: langStore.fileSizeLabel },
                  ]}
                />
                <ShowReference
                  label={langStore.AssociatedDocumentEditionTypeLabel}
                  selectedValue={langStore.displayIdByLang(
                    typeValue?.displayId
                  )}
                />
                <ShowMultiLine
                  value={notes}
                  label={langStore.AssociatedDocumentEditionNotesLabel}
                />
                <ShowMultiLine
                  value={publisherConfigurationDisplay}
                  label={
                    langStore.AssociatedDocumentEditionPublisherConfigurationDisplayLabel
                  }
                />
                <ShowMultiLine
                  value={authorsDisplay}
                  label={langStore.AssociatedDocumentEditionAuthorsDisplayLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
